var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.isMdi)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):(_setup.isFaIcon)?_c('font-awesome-icon',{staticClass:"fa-fw",attrs:{"icon":_setup.faIcon}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }